<script setup>
	import { ref } from 'vue';
	import VideoPopup from 'shared/components/VideoElements/videoPopup.vue';
	import { DsButtonPlay } from '@coloplast/design-system';
	import '@coloplast/design-system/dist/components/button/ds-button-play.css';
	import { track_content_engagement } from 'shared/services/tracking/contentTrackingService';

	const props = defineProps({
		videoUrl: {
			type: String,
		},
		caption: {
			type: String,
		},
		isLandscape: {
			type: Boolean,
			default: true,
		}
	});

	const
		videoIsPlaying = ref(false),
		videoUrl = ref(null);

	function setVideoUrl() {
		videoUrl.value = props.videoUrl;
		videoIsPlaying.value = true;
		track_content_engagement('video', 'start', props.caption || 'no_data', props.videoUrl);
	}

	function closePopup() {
		videoUrl.value = null;
		videoIsPlaying.value = false;
	}
</script>

<template>
	<div class="c-video-card__playcontainer" @click="setVideoUrl" data-testid="video-play">
		<DsButtonPlay type="button"
					  aria-label-play="Play video"
					  icon-name="play"
					  size="lg"
					  :variant="isLandscape ? 'inverted' : 'primary'"
					  class="c-video-card__playbutton" />
	</div>
	<VideoPopup v-if="videoIsPlaying && videoUrl"
				:video-url="videoUrl"
				@close-popup="closePopup" />
</template>
